import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
/* import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox"; */
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Copyright from "../components/Copyright";
import { Link, Outlet, useNavigate } from "react-router-dom";
import BlueIcon from "../assets/Blue.png";
import LoginImage from "../assets/digital3.jpg";
import auth from "../services/auth";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import LoadingScreen from "../components/LoadingScreen";
import HiperLink from "@mui/material/Link";
import api from "../services/api";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [checked, setChecked] = useState(false);
  const [incorrectPassword, setIncorrectPassword] = useState(false);
  const [accountNotFound, setAccountNotFound] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  /*  const handleRemember = () => {
    setChecked(!checked);
  }; */

  useEffect(() => {
    if (auth.token() && auth.type() === "admin") {
      navigate("/dashboard");
    }
    if (auth.token() && auth.type() === "client") {
      navigate("/home");
    }
  }, [navigate]);

  const handleSubmit = (event) => {
    setLoading(true);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    const password = data.get("password");
    const login = {
      email,
      password,
    };
    api
      .post("login", login)
      .then((response) => {
        setLoading(false);
        if (response.data.user_type === "admin") {
          console.log(response.data)
          auth.login(
            response.data.access_token,
            response.data.user_type,
            () => {
              navigate("/dashboard");
            }
          );
        }
        if (response.data.user_type === "client") {
          auth.login(
            response.data.access_token,
            response.data.user_type,
            () => {
              navigate("/home");
            }
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        if (error.response.status === 404) {
          setAccountNotFound(true);
        }
        if (error.response.status === 401) {
          setIncorrectPassword(true);
        }
      });
  };

  const handleDesableError = (ev) => {
    if (ev) {
      setAccountNotFound(false);
      setIncorrectPassword(false);
    }
  };

  return loading ? (
    <LoadingScreen />
  ) : (
    <>
      <Outlet />
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${LoginImage})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                backgroundImage: `url(${BlueIcon})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                height: "20vh",
                width: "100%",
                mt: 1,
              }}
            />

            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                error={accountNotFound}
                helperText={
                  accountNotFound && "Essa conta não existe! Faça seu cadastro."
                }
                onClick={handleDesableError}
                required
                fullWidth
                id="email"
                label="E-mail"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <FormControl
                error={incorrectPassword}
                sx={{ mt: 2 }}
                fullWidth
                variant="outlined"
              >
                <InputLabel required htmlFor="password">
                  Senha
                </InputLabel>
                <OutlinedInput
                  required
                  onClick={handleDesableError}
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? (
                          <Visibility color="primary" />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  autoComplete="current-password"
                  label="Senha"
                />
                {incorrectPassword && (
                  <FormHelperText>Senha incorreta</FormHelperText>
                )}
              </FormControl>

              {/*  <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleRemember}
                    checked={checked}
                    value="remember"
                    color="primary"
                  />
                }
                label="Mantenha-me conectado"
              /> */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Login
              </Button>
              <Grid container>
                <Grid item xs>
                  <HiperLink
                    sx={{ display: "none" }}
                    component={Link}
                    to="/newPassword"
                  >
                    Esqueceu a senha?
                  </HiperLink>
                </Grid>
                <Grid item>
                  <HiperLink component={Link} to="/register">
                    Não tem uma conta? Cadastre-se já!
                  </HiperLink>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
